export default function PlayIcon({ className = '' }) {
  return (
    <svg
      className={className}
      width="9"
      height="11"
      viewBox="0 0 9 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.5 0.5V10.5L8.5 5.5L0.5 0.5Z"
        fill="currentColor"
      />
    </svg>
  );
}

